<script>
    import { CornerItem, RoundMock } from '@/components'

    export let data = {
        title: '',
        description: '',
        icon: '',
        circleColor: '#000000',
        corner: 'left-top'
    }
</script>

<CornerItem class="corner-item" corner={data.corner}>
    <!-- <div class="circle-wrapper">
        <div class="circle" style={`background-color: ${data.circleColor};`} />
        <RoundMock class="round-mock" />
    </div> -->
    <img class="icon" src={`./img/icons/${data.icon}.png`} />
    <div class="title">{data.title}</div>
    <div class="description">{@html data.description}</div>
</CornerItem>

<style lang="scss" module>
    .icon {
        display: block;
        margin: 0 auto;
        width: auto;
        height: 192px;
        margin-bottom: 30px;
    }

    .title {
        font-size: 36px;
        line-height: 45px;
        text-align: center;
        color: #343B45;
        font-weight: 700;
    }
    
    .description {
        margin-top: 14px;
        font-size: 18px;
        line-height: 23px;
        text-align: center;
    }

    div.corner-item {
        width: 490px; 
        height: 508px; 
        box-shadow: 9.12px 6.08px 112.48px rgba(201, 100, 19, 0.14);
    }

    @media (max-width: 834px) {
        div.corner-item {
            width: 100%;
            height: 400px;

            br {
                display: none;
            }

            .title {
                font-size: 30px;
                line-height: 38px;
            }

            .description {
                padding: 0 30px;
            }
        }
    }

    @media (max-width: 420px) {
        div.corner-item {
            height: 280px;

            .icon {
                height: 98px;
            }

            .title {
                font-size: 22px;
                line-height: 28px;
            }

            .description {
                font-size: 14px;
                line-height: 18px;
                margin-top: 10px;
            }
        }
    }
</style>
